import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import { DASHBOARD_INDICATORS_LIST_QUERY } from '../queries/dashboardIndicatorsListQuery';
import DashboardIndicatorComponent from './DashboardIndicatorComponent';
import { Grid } from '@mui/material';
import WrappedFakeText from 'components/common/WrappedFakeText';

const DashboardIndicatorsContainer = ({ userId, groupName, dashboardIds }) => {
  const selectedLanguage = i18n.language;

  const { data, loading } = useQueryWithErrorHandling(DASHBOARD_INDICATORS_LIST_QUERY, {
    variables: {
      userId: parseInt(userId),
      groupName,
      dashboardIds,
      lang: selectedLanguage
    },
    fetchPolicy: 'no-cache'
  });

  if (loading) {
    return <WrappedFakeText lines={5} my={1} />;
  }

  return (
    <Grid container spacing={2} my={0}>
      {data?.dashboardIndicators?.map((dashboardIndicator, index) => (
        <DashboardIndicatorComponent key={index} dashboardIndicator={dashboardIndicator} />
      ))}
    </Grid>
  );
};

DashboardIndicatorsContainer.propTypes = {
  userId: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
  dashboardIds: PropTypes.array.isRequired
};

export default DashboardIndicatorsContainer;
